import { createReduxAsyncThunk } from 'shared/utils';
import { carsAPI } from 'entities/cars';

import { CARS_STATE } from '../../constants';

import { CarsState } from '../../types';

export const getLocationSharingConstraints = createReduxAsyncThunk<CarsState['locationSharingConstraints']['data']>(
  `${CARS_STATE}/getLocationSharingConstraints`,
  async () => {
    const { data } = await carsAPI.getCarsLocationSharingConstraints();
    return data;
  }
);
